// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".questionnaire[data-v-d6b5bc50]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}[dir] .questionnaire-wrapper[data-v-d6b5bc50]{margin-bottom:16px}[dir] .answer[data-v-d6b5bc50],[dir] .title[data-v-d6b5bc50]{margin-bottom:4px}", ""]);
// Exports
module.exports = exports;
